/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SharepointDriveData,
  SharepointDriveData$inboundSchema,
  SharepointDriveData$Outbound,
  SharepointDriveData$outboundSchema,
} from "./sharepointdrivedata.js";
import {
  SharepointFileData,
  SharepointFileData$inboundSchema,
  SharepointFileData$Outbound,
  SharepointFileData$outboundSchema,
} from "./sharepointfiledata.js";
import {
  SharepointSiteData,
  SharepointSiteData$inboundSchema,
  SharepointSiteData$Outbound,
  SharepointSiteData$outboundSchema,
} from "./sharepointsitedata.js";

export type SharepointData = {
  site: SharepointSiteData;
  drive: SharepointDriveData | null;
  files: Array<SharepointFileData>;
};

/** @internal */
export const SharepointData$inboundSchema: z.ZodType<
  SharepointData,
  z.ZodTypeDef,
  unknown
> = z.object({
  site: SharepointSiteData$inboundSchema,
  drive: z.nullable(SharepointDriveData$inboundSchema),
  files: z.array(SharepointFileData$inboundSchema),
});
/** @internal */
export type SharepointData$Outbound = {
  site: SharepointSiteData$Outbound;
  drive: SharepointDriveData$Outbound | null;
  files: Array<SharepointFileData$Outbound>;
};

/** @internal */
export const SharepointData$outboundSchema: z.ZodType<
  SharepointData$Outbound,
  z.ZodTypeDef,
  SharepointData
> = z.object({
  site: SharepointSiteData$outboundSchema,
  drive: z.nullable(SharepointDriveData$outboundSchema),
  files: z.array(SharepointFileData$outboundSchema),
});

export function sharepointDataToJSON(sharepointData: SharepointData): string {
  return JSON.stringify(SharepointData$outboundSchema.parse(sharepointData));
}
export function sharepointDataFromJSON(
  jsonString: string,
): SafeParseResult<SharepointData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SharepointData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SharepointData' from JSON`,
  );
}
